pageId = 'teams-dashboards-upcoming_todos-show'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-dashboard').addClass 'active'

  tower.adjustTodo()

  # 对项目进行了筛选时，不执行滚动加载
  projectGuid = $('.selector[data-type="project"]').data('value')
  if !projectGuid || projectGuid == -1
    tower.scrollLoad $page, ->
      $.ajax
        url: location.href
        dataType: 'html'
        type: 'get'
        data:
          till_project_guid: $('.todo:last').data 'project-guid'
        success: (result) ->
          return unless result
          $result = $(result)
          tower.adjustTodo $result
          tower.adjustReadableDate $result
          tower.adjustReadableTime $result
          $('.projects-holder').append $result
